<div class="container">
    <div mat-dialog-title class="dialog-header aum-typo-headline-3">
        <div class="dialog-title">
            <span class="title-span"> {{ 'aumico_print_preview_rename_section_title_dialog_title' | i18next }}</span>
        </div>
        <div class="seprator"></div>
        <div class="close-dialog">
            <mat-icon (click)="closeDialog()" svgIcon="interface-delete 1"></mat-icon>
        </div>
    </div>
    <div mat-dialog-content class="mat-dialog-content">
        <aum-input
            placeholder="{{ 'aumico_print_preview_rename_section_title_dialog_input_field_placeholder' | i18next }}"
            [aumFormControl]="titleFormControl"
        >
            <aum-form-field-label>
                {{ 'aumico_print_preview_rename_section_title_dialog_input_field_title' | i18next }}
            </aum-form-field-label>
        </aum-input>
    </div>
    <div class="actions-footer">
        <mat-dialog-actions>
            <div class="buttons">
                <button aum-button (click)="closeDialog()" color="basic">{{ 'aumico_button_cancel' | i18next }}</button>
                <button aum-button [disabled]="titleFormControl.invalid" (click)="onSaveClicked()" color="primary">
                    {{ 'aumico_button_save' | i18next }}
                </button>
            </div>
        </mat-dialog-actions>
    </div>
</div>
